import { Button, DatePicker, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import { useNavigate } from "react-router-dom";

const SaveMerchantOrderUnsave = ({
  open,
  close,
  setLoading,
  getMerchantOrderUnsaveList,
  //   getMerchantOrderSaveList,.
  po_number,
  po_number_id,
  merchant_user_id,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const navigate = useNavigate();

  const handleSaveToMerchantOrder = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("po_number", po_number);
    formdata.append("po_number_id", po_number_id);
    formdata.append(
      "commissary_user_id",
      userData.data.userscomemployee.user_id
    );
    formdata.append("merchant", merchant_user_id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    // invoice_from
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary-employee/save-merchant-order-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to merchant order successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            navigate(-1);
            getMerchantOrderUnsaveList();

            // getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Save Prepared Merchant Order"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleSaveToMerchantOrder}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="invoice_number"
            label="Invoice Number"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set Invoice" size="large" />
          </Form.Item>

          <Form.Item
            name="invoice_date"
            label="Invoice Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"MM/DD/YYYY"}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SaveMerchantOrderUnsave;
